import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { AuthContext } from '../context/AuthContext'

const Home = () => {
  const { user } = useContext(AuthContext)

  return (
    <div className='min-h-screen'>
      {/* Hero Section */}
      <div className='bg-gradient-to-r from-primary-600 to-primary-800 text-white'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24'>
          <div className='text-center'>
            <h1 className='text-5xl font-bold mb-6'>Welcome to EduFlow</h1>
            <p className='text-xl mb-8 text-primary-100'>
              Your Gateway to Quality Online Education
            </p>
            <div className='space-x-4'>
              <Link
                to={user ? '/courses' : '/register'}
                className='bg-white text-primary-600 px-8 py-3 rounded-md text-lg font-medium hover:bg-gray-100 inline-block'
              >
                Get Started
              </Link>
              <Link
                to='/courses'
                className='bg-primary-700 text-white px-8 py-3 rounded-md text-lg font-medium hover:bg-primary-800 inline-block'
              >
                Browse Courses
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16'>
        <h2 className='text-3xl font-bold text-center mb-12'>
          Why Choose EduFlow?
        </h2>
        <div className='grid md:grid-cols-3 gap-8'>
          <div className='text-center'>
            <div className='bg-primary-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4'>
              <svg
                className='w-8 h-8 text-primary-600'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
                />
              </svg>
            </div>
            <h3 className='text-xl font-semibold mb-2'>Quality Courses</h3>
            <p className='text-gray-600'>
              Access a wide range of courses taught by expert instructors
            </p>
          </div>
          <div className='text-center'>
            <div className='bg-primary-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4'>
              <svg
                className='w-8 h-8 text-primary-600'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                />
              </svg>
            </div>
            <h3 className='text-xl font-semibold mb-2'>Track Progress</h3>
            <p className='text-gray-600'>
              Monitor your learning journey with detailed progress tracking
            </p>
          </div>
          <div className='text-center'>
            <div className='bg-primary-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4'>
              <svg
                className='w-8 h-8 text-primary-600'
                fill='none'
                stroke='currentColor'
                viewBox='0 0 24 24'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                />
              </svg>
            </div>
            <h3 className='text-xl font-semibold mb-2'>Learn at Your Pace</h3>
            <p className='text-gray-600'>
              Study anytime, anywhere with flexible learning schedules
            </p>
          </div>
        </div>
      </div>

      {/* Creators Section */}
      <div className='bg-white border-t border-gray-200'>
        <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center'>
          <h2 className='text-2xl font-bold text-gray-900 mb-4'>
            Project Creators
          </h2>
          <div className='space-y-2 text-gray-700'>
            <p>
              Hajar Mohamad -{' '}
              <a
                href='https://github.com/hajarmohamad965-byte'
                target='_blank'
                rel='noreferrer'
                className='text-primary-600 hover:underline'
              >
                github.com/hajarmohamad965-byte
              </a>
            </p>
            <p>
              Amina Fanar -{' '}
              <a
                href='https://github.com/Amina23fa'
                target='_blank'
                rel='noreferrer'
                className='text-primary-600 hover:underline'
              >
                github.com/Amina23fa
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Home
